export const APP_EMITTER_EVENTS = {
    clearForm: "clearForm",
    replaceUuids: "replaceUuids",
    blockLayoutScroll: "blockLayoutScroll"
}
